import React from "react";
import { Card, Button, Typography, Space, Skeleton } from "antd";
import { RedoOutlined, UserOutlined } from "@ant-design/icons";
import { formatRelativeTime } from "../../utils/date";
import { capitalizeName } from "../../utils/device";
import IssueTable from "./IssueTable";
import IssueTableSkeleton from "../../components/Skeleton/IssueTableSkeleton";

const { Text } = Typography;

const UserIssueCard = ({
  username,
  displayName,
  issues,
  userData,
  onRefreshUser,
}) => {
  const hasError = userData?.error;
  const errorMessage = userData?.errorMessage;
  const isRefreshing = userData?.isRefreshing;
  const showSkeleton = isRefreshing && !hasError;

  return (
    <Card
      className="user-issue-card"
      title={
        <Space>
          <UserOutlined />
          <Text strong>{capitalizeName(displayName || username)}</Text>
          {isRefreshing ? (
            <Skeleton.Input active size="small" style={{ width: 72 }} />
          ) : (
            <Text type="secondary">({issues.length} issues)</Text>
          )}
        </Space>
      }
      extra={
        <Space>
          {isRefreshing ? (
            <Skeleton.Input active size="small" style={{ width: 100 }} />
          ) : (
            userData?.lastUpdated && (
              <Text type="secondary" className="last-updated">
                Updated {formatRelativeTime(userData.lastUpdated / 1000)}
              </Text>
            )
          )}
          <Button
            size="small"
            icon={<RedoOutlined />}
            onClick={() => onRefreshUser(username)}
            disabled={isRefreshing}
            title="Refresh this user"
          />
        </Space>
      }
    >
      <div className="user-table-wrapper">
        {showSkeleton ? (
          <IssueTableSkeleton rows={issues.length > 0 ? issues.length : 4} />
        ) : (
          <IssueTable
            issues={issues}
            hasError={hasError}
            errorMessage={errorMessage}
            username={username}
          />
        )}
      </div>
    </Card>
  );
};

export default UserIssueCard;
